<template>
  <div class="access-over-view">
    <over-view-top-line :topData="overViewTopData" />
    <div class="access-over-view-line">
      <div style="flex: 1;padding: 0.12rem 0.12rem 0.15rem 0.12rem;background-color: #fff;border-radius: 0.06rem;margin-right: 0.12rem">
        <h2>设备分布</h2>
        <div style="display: flex;justify-content: left;align-items: center;margin-left: 0.26rem">
          <div style="position: relative">
            <div style="position: absolute;left: 0.313rem;top: 0.31rem;z-index: 1001">
              <div class="access-over-view-line-ring-num">{{ overViewTopData[0][0].value || 0 }}<span>台</span></div>
              <div class="access-over-view-line-ring-name">设备总数</div>
            </div>
            <common-ring
              width="0.97rem"
              height="0.97rem"
              commonRingId="deviceRing"
              :isEmphasis="false"
              :seriesItemStyle="seriesItemStyle"
              :colorList="commonColorList"
              :ringLegend="commonRingLegend"
              :ringRadius="commonRingRadius"
              :ringTitle='deviceTitle'
              :ringData='deviceInfo'
              @getPercentList="getPercentList1"
            />
          </div>
          <div class="container-middle-right">
            <div class="container-middle-right-item" v-for="(item, i) in deviceDistributionList">
              <div class="container-middle-right-item-box" :style="{background: item.background}"></div>
              <div class="container-middle-right-item-text">{{ item.name }}</div>
              <div class="container-middle-right-item-num">
                {{ item.num || 0 }}<span style="font-size: 0.06rem">台</span>
              </div>
              <div class="container-middle-right-item-num-percentage">{{ percentList1[i] || 0 }}<span style="font-size: 0.06rem">%</span></div>
            </div>
          </div>
        </div>
      </div>
      <div style="flex: 1;padding: 0.12rem 0.12rem 0.15rem 0.12rem;background-color: #fff;border-radius: 0.06rem;">
        <h2>设备场景</h2>
        <div style="display: flex;justify-content: left;margin-left: 0.26rem">
          <div style="position: relative">
            <div style="position: absolute;left: 0.313rem;top: 0.31rem;z-index: 1001">
              <div class="access-over-view-line-ring-num">2<span>种</span></div>
              <div class="access-over-view-line-ring-name">场景类型</div>
            </div>
            <common-ring
              commonRingId="sceneRing"
              width="0.97rem"
              height="0.97rem"
              :isEmphasis="false"
              :seriesItemStyle="seriesItemStyle"
              :colorList="commonColorList"
              :ringRadius="commonRingRadius"
              :ringLegend="commonRingLegend"
              :ringTitle='sceneTitle'
              :ringData='sceneInfo'
              @getPercentList="getPercentList3"
            />
          </div>
          <div class="container-middle-right" style="display: flex;flex-direction: column;justify-content: center">
            <div class="container-middle-right-item container-middle-right-item2" v-for="(item, a) in sceneList">
              <div class="container-middle-right-item-box" :style="{background: item.background}"></div>
              <div class="container-middle-right-item-text">{{ item.name }}</div>
              <div class="container-middle-right-item-num">
                {{ item.num || 0 }}<span style="font-size: 0.06rem">台</span>
              </div>
              <div class="container-middle-right-item-num-percentage">{{ percentList3[a] || 0 }}<span style="font-size: 0.06rem">%</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="finance-over-view-line" style="margin-top: 0.12rem;">
      <h2 style="position: absolute;top: 6.2%">识别统计</h2>
      <chart-time-select @getData="getLiftRecordStatics" style="margin-right: 0.14rem;top: 7.5%;justify-content: right;width: 100%"/>
      <common-line
        style="z-index: 1000"
        lineId='cardRecordLine'
        legendRight="478px"
        legendTop="2.7%"
        gridLeft="1.7%"
        :height='"1.73rem"'
        :legendData="cardRecordLegendData"
        :xAxis="cardRecordXAxis"
        :yAxis='cardRecordYAxis'
        :series='cardRecordSeries'
      />
    </div>
  </div>

</template>

<script>
import CommonRing from '../../../components/Echarts/Pie/Pie/commonRing'
import {api} from '../../api/LadderControl'
import CommonLine from '../../../components/Echarts/Line/commonLine'
import ChartTimeSelect from "../../../components/Echarts/ChartTimeSelect/newChartTimeSelect";
import OverViewTopLine from "../../../components/OverView/newOverViewTopLine";

export default {
  components: {
    ChartTimeSelect,
    CommonLine,
    CommonRing,
    OverViewTopLine
  },
  name: 'ladder-over-view',
  data () {
    return {
      overViewTopData: [
        [
          {
            code1: 'total',
            code2: 'invoiceCount',
            name: '梯控设备',
            value: "0",
            unit: "台",
            color: "#fff",
            background: "linear-gradient(to right, rgba(52, 147, 235, .8), rgba(54, 212, 233, .8))",
            icon: require('../../../assets/overview_top_icon/tksb.png')
          },
          {
            code1: 's',
            code2: 'invoiceCount',
            name: '在线设备',
            value: "0",
            unit: "台",
            color: "#fff",
            background: "linear-gradient(to right, rgba(51, 201, 96, .8), rgba(43, 205, 205, .8))",
            icon: require('../../../assets/overview_top_icon/tkzxsb.png')
          },
          {
            code1: 'p',
            code2: 'invoiceCount',
            name: '离线设备',
            value: "0",
            unit: "台",
            color: "#fff",
            background: "linear-gradient(to right, rgba(255, 121, 121, .8), rgba(254, 166, 208, .8))",
            icon: require('../../../assets/overview_top_icon/tklxsb.png')
          },
          // {
          //   code1: 'receipt',
          //   code2: 'invoiceCount',
          //   name: '门禁类型',
          //   value: "0",
          //   unit: "种",
          //   color: "#fff",
          //   background: "linear-gradient(to right, rgba(83, 107, 248, 1), rgba(38, 208, 206, 1))",
          //   icon: require('../../../assets/overview_top_icon/access_type_num.png')
          // },
        ]
      ],
      commonColorList: ['#5B9BD5', '#ED7D31', '#C2A753', '#4BB66E', '#FFA336', '#53A5BC'],
      onlineTitle: '',
      deviceTitle: '',
      sceneTitle: '',
      deviceInfo: [],
      onlineInfo: [],
      sceneInfo: [],

      cardRecordRadio: false,
      cardRecordTitle: '识别统计',
      cardRecordLegendData: [],
      cardRecordXAxis: {
        type: 'category',
        name: '日期',
        nameTextStyle: {
          color: '#000',
          fontSize: 'calc(100vw * 14/ 1920)',
        },
        boundaryGap: false,
        axisTick: {
          show: false, //是否显示刻度
        },
        axisLabel: {
          color: '#000',
          fontSize: 'calc(100vw * 14/ 1920)',
        },
        // splitLine: {
        //   show: true,
        //   lineStyle: {
        //     type: 'dotted',
        //     color: 'rgba(50,50,50,0.4)'
        //   }
        // },
        axisLine: {
          show: true,
          lineStyle: {
            type: 'dotted',
            color: 'rgba(50,50,50,0.4)',//坐标线的颜色
          }
        },
        data: []
      },
      cardRecordYAxis: [
        {
          type: 'value',
          name: '人次',
          nameTextStyle: {
            color: '#000',
            fontSize: 'calc(100vw * 14/ 1920)',
          },
          axisTick: {
            show: false, //是否显示刻度
          },
          axisLabel: {
            color: '#000',
            fontSize: 'calc(100vw * 14/ 1920)',
          },
          splitLine: {
            lineStyle: {
              type: 'dotted',
              color: 'rgba(50,50,50,0.4)'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'dotted',
              color: 'rgba(50,50,50,0.4)',//坐标线的颜色
            }
          },
        }
      ],
      cardRecordSeries: [],
      onlineColorList: ['#44c23b', '#f54659'],
      commonRingLegend: {
        show: false,
        left: 'center',
        bottom: 0,
      },
      seriesItemStyle:  {
        borderRadius: 10,
        borderColor: '#fff',
        borderWidth: 2
      },
      commonRingRadius: ['48%', '85%'],
      percentList1: [],
      percentList3: [],
      deviceDistributionList: [],
      sceneList: []
    }
  },

  created() {
    this.commonColorList = [
      new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
        {offset: 0, color: '#78C4FF'},
        {offset: 1, color: '#346FFF'},
      ]),
      new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
        {offset: 0, color: '#FFDB94'},
        {offset: 1, color: '#FFAF29'}
      ]),
      new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
        {offset: 0, color: '#32D74B'},
        {offset: 1, color: 'rgba(50, 215, 75, 0.50)'}
      ]),
      new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
        {offset: 0, color: 'rgba(255, 121, 121, 1)'},
        {offset: 1, color: 'rgba(255, 167, 209, 1)'}
      ]),
    ]
  },

  mounted () {
    this.getLiftDeviceOverview()
    this.getLiftGatewayOverview()
  },

  methods: {
    // 获取圆环百分比
    getPercentList1(e) {
      this.percentList1 = e;
    },

    // 获取圆环百分比
    getPercentList3(e) {
      this.percentList3 = e;
    },


    // 获取最大值
    calMax(arr) { // arr是传入的series
      const yAxisData = [[], []]  // 连个y轴，用两个数组将不同y轴对应数据分开
      const maxArr = [] // 用来缓存计算出来的所有Y轴的最大值
      arr.forEach(item => {
        if (item.yAxisIndex === 0) { // 根据数据对应的y轴的下标将数据分别缓存在yAxisData中
          yAxisData[0] = yAxisData[0].concat(item.data)
        }
        if (item.yAxisIndex === 1) {
          yAxisData[1] = yAxisData[1].concat(item.data)
        }
      })
      yAxisData.forEach((item, index) => {
        let max = Number(item[0])
        item.forEach((i, index) => {
          if (Number(i) && Number(i) > max) {
            max = Number(i)
          }
        })
        maxArr[index] = max
      })
      return maxArr
    },


    getLiftRecordStatics (type, startTime, endTime) {
      api.getLiftRecordStatictics({
        startTime: startTime || '',
        endTime: endTime || '',
        timeType: type || 'DAY'
      })
        .then(data => {
          let xData = []
          let seriesData = []
          data.map(v => {
            seriesData.push(v.count)
            if (type === 1) {
              let dateArr = v.date.split('-')
              let showData = `${dateArr[1]}-${dateArr[2]}`
              xData.push(showData)
            } else {
              xData.push(v.date)
            }
          })
          this.cardRecordXAxis.data = xData
          this.cardRecordSeries = [
            {
              yAxisIndex: 0,
              name: '',
              type: 'line',
              stack: '统计',
              // areaStyle: {},
              min: 0,
              max: 5,
              interval: 1,
              smooth:true,
              symbol: 'circle',
              symbolSize: 5,
              sampling: 'average',
              itemStyle: {
                color: '#0A84FF'
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(10, 132, 255, 0.40)'
                }, {
                  offset: 1,
                  color: 'rgba(10, 132, 255, 0)'
                }])
              },
              data: seriesData
            },
          ]
          const maxNumber = this.calMax(this.cardRecordSeries);
          // console.log(maxNumber, 'maxNumber');
          // const minNumber = 0;
          let intervalList = [];
          this.cardRecordYAxis.forEach((item, index) => {
            if (this.cardRecordYAxis[index]) {  // 做个截断这样最大值和最小值也可以是手动传入的，例如y轴是月份等固定的数，可以手动传入
              item.max = maxNumber[index]
              item.minNum = 0;
              // console.log(item.max, 'item.max')
              if (item.max > 0) {
                const maxDigit = Math.floor(Math.log(Math.abs(item.max)) / Math.log(10)) - 1  // 根据求最大值以10为底的对数计算最大值得位数（不用管是不是小数，都是可以实现的）
                // Math没有以10为底的对数求法，这里用了对数的换底公式
                // 减1是因为省略了一步，如果直接用位数继续下面的计算，求出来的最大值可能会比数据真实的最大值大太多，图形一般会集中分布在grid的下方
                // 减去一位再进行计算，计算所得的最大值一般会比数据的最大值低一位，这样图形整体就比较丰满，一般距离图表顶部一格左右
                const maxMultiple = Math.pow(10, maxDigit)
                // 用pow方法记录我们需要最终精确地位数
                item.max = Math.ceil((Math.abs(item.max) * 1.1) / maxMultiple) * maxMultiple
                // 先将数据最大值放大1.2倍（根据自己的需要），在利用之前的记录的精度对齐向上取整，这样就能获取到你想要的数据（10， 100， 5000, 0.3， 0.005, ...）
              } else {
                item.max = 0
                // 这里如果最大值<= 0，我直接取0， 根据需求自己确定
              }
              if (item.minNum >= 0) {
                item.minNum = 0
              } else {
                const minDigit = Math.floor(Math.log(-item.minNum) / Math.log(10)) - 1
                const minMultiple = Math.pow(10, minDigit)
                item.minNum = -Math.ceil((Math.abs(item.minNum) * 1.1) / minMultiple) * minMultiple
                // 这里只给最小值为负时设置的算法，因为为正时直接赋值为0，图形会更好
              }
              // 设置Interval，我这里所有的splitNumber都默认为5，也可以选择自己传入，一幅丰满且适用于多种多样是坐标系图就完成了
              item.interval1 = (item.max - item.minNum) / 5
              let integer = Math.ceil(item.interval1);
              let length = String(integer).length;
              item.interval = Math.ceil(integer/Math.pow(10,length-1))*Math.pow(10,length-1)
              if (item.interval === 0) {
                item.interval = 1;
              } else if(item.interval < 10 && item.interval !== 5 && item.interval !== 2 && item.interval !== 1  && item.interval !== 0) {
                item.interval = 10;
              }
              item.max = item.interval * 5 === 0 ? 1 : item.interval * 5;
              // console.log(item.interval, 'item.interval');
            }
          });
          // console.log(this.cardRecordYAxis, 'this.cardRecordYAxis');
          // if (intervalList[0] > intervalList[1]) {
          this.cardRecordYAxis[0].min = 0;
        })
    },

    getLiftDeviceOverview () {
      api.getLiftDeviceOverview()
        .then(data => {
          this.deviceInfo = [
            {name: '单层设备', value: data.singlePassDeviceCount },
            {name: '双层设备', value: data.doublePassDeviceCount },
            {name: '单双层设备', value: data.allPassSceneDeviceCount }
          ]
          this.sceneInfo = [
            {name: '园区场景', value: data.parkSceneDeviceCount },
            {name: '楼栋场景', value: data.buildingSceneDeviceCount },
          ]
          this.deviceDistributionList = [];
          this.sceneList = [];
          let obj = { name: '单层设备', num: data.singlePassDeviceCount, background: "linear-gradient(to bottom, #78C4FF, #346FFF)" };
          let obj2 = { name: '双层设备', num: data.doublePassDeviceCount, background: "linear-gradient(to bottom, #FFDB94, #FFAF29)" };
          let obj3 = { name: '单双层设备', num: data.allPassSceneDeviceCount, background: "linear-gradient(to bottom, rgba(50, 215, 75, 1), rgba(50, 215, 75, 0.50))" };
          let obj31 = { name: '园区场景', num: data.parkSceneDeviceCount, background: "linear-gradient(to bottom, #78C4FF, #346FFF)" };
          let obj32 = { name: '楼栋场景', num: data.buildingSceneDeviceCount, background: "linear-gradient(to bottom, #FFDB94, #FFAF29)" };
          this.deviceDistributionList.push(obj);
          this.deviceDistributionList.push(obj2);
          this.deviceDistributionList.push(obj3);
          this.sceneList.push(obj31);
          this.sceneList.push(obj32);
          // this.sceneList.push(obj33);
          // this.sceneList.push(obj34);
        })
    },

    getLiftGatewayOverview () {
      api.getLiftGatewayOverview()
        .then(data => {
          this.onlineInfo = [
            {name: '在线', value: data.onlineDeviceCount },
            {name: '离线', value: data.offlineDeviceCount }
          ]
          this.overViewTopData[0][0].value = data.onlineDeviceCount + data.offlineDeviceCount;
          this.overViewTopData[0][1].value = data.onlineDeviceCount;
          this.overViewTopData[0][2].value = data.offlineDeviceCount;
        })
    },

  },

  watch: {}
}
</script>

<style lang="less" scoped>
.access-over-view {
  padding: 0.16rem 0.12rem 0 0.16rem;
  background-color: rgba(240, 240, 247, 1);
  .access-over-view-line {
    height: unset;
    display: flex;
    justify-content: space-between;
    .access-person-count-all {
      display: flex;
      justify-content: center;
      flex-direction: column;
      .access-person-count-box {
        width: 160px;
        height: 120px;
        padding: 20px 10px;
        border-right: 1px solid #eee;
        border-bottom: 1px solid #eee;
        color: #666666;
        display: flex;
        justify-content: center;
        flex-direction: column;
        .access-person-count {
          font-size: 32px;
          font-weight: 500;
        }
        .access-person-tip {
          font-size: 14px;
        }
      }
    }
    .access-over-view-line-left {
      width: 49%;
      padding: 10px 10px;
      border: 1px solid #eeeeee;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      overflow: hidden;
    }
    .access-over-view-line-right {
      width: 49%;
      padding: 10px 10px;
      border: 1px solid #eeeeee;
      border-radius: 10px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
    }

    .daily-income-info {
      border-bottom: 1px solid #eeeeee;
      display: flex;
      justify-content: space-between;
      .daily-income-info-item {
        color: #666666;
        padding: 0 20px;
        margin: 22px 0;
        .daily-income-info-amount {
          font-size: 24px;
          line-height: 50px;
        }
        .daily-income-info-name {
          font-size: 14px;
          line-height: 24px;
        }
      }
    }

    .el-table {
      thead {
        th {
          padding: 6px 0;
          text-align: center;
          color: #666666;
          background-color: #eff1f5;
        }
      }
      tbody {
        td {
          padding: 6px 0;
          text-align: center;
          color: #FF0000;
        }
      }
    }

    .el-pagination {
      padding: 0;
    }
  }
}
.finance-over-view-line {
  margin-bottom: 0.12rem;
  padding: 0.12rem;
  position: relative;
  border: unset;
  border-radius: 0.06rem;
  background-color: #fff;
  height: unset;
}
h2 {
  font-size: 0.1rem;
  text-align: left;
  margin-bottom: 0.12rem;
}
.container-middle-right {
  margin-left: 0.18rem;
  .container-middle-right-item {
    width: 1.87rem;
    padding: 0.06rem;
    background: #F3F3F3;
    border-radius: 0.04rem;
    display: flex;
    justify-content: left;
    align-items: center;
    margin-top: 0.06rem;
    text-align: left;
    .container-middle-right-item-box {
      width: 0.17rem;
      height: 0.1rem;
      background: linear-gradient(to bottom, rgba(120, 196, 255, 1), rgba(52, 111, 255, 1));
      border-radius: 4px;
    }
    .container-middle-right-item-text {
      min-width: 60px;
      margin-left: 0.08rem;
      font-size: 0.075rem;
      color: black;
      margin-right: 0.24rem;
    }
    .container-middle-right-item-num {
      min-width: 40px;
      font-size: 0.1rem;
      font-family: 江城斜黑体, 江城斜黑体;
      font-weight: 600;
      background: linear-gradient(180deg, #78C4FF 0%, #346FFF 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .container-middle-right-item-num-percentage {
      margin-left: 0.2rem;
      font-size: 0.1rem;
      font-family: 江城斜黑体, 江城斜黑体;
      font-weight: 600;
      background: linear-gradient(180deg, #78C4FF 0%, #346FFF 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .container-middle-right-item2 {
    margin-top: 0.04rem;
  }
}
.access-over-view-line-ring-num {
  font-size: 0.145rem;
  font-family: 江城斜黑体, 江城斜黑体;
  color: #4194F7;
  margin-bottom: 0.02rem;
  span {
    font-size: 0.09rem;
  }
}
.access-over-view-line-ring-name {
  font-size: 0.085rem;
}
.container-middle-right  .container-middle-right-item:first-child {
  margin-top: 0;
}
.container-middle-right2  .container-middle-right-item:nth-child(2) .container-middle-right-item-num, .container-middle-right2  .container-middle-right-item:nth-child(2)  .container-middle-right-item-num-percentage {
  background: linear-gradient(180deg, #FF7979 0%, #FFA7D1 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
/deep/.commonRingItems {
  background-color: rgba(245, 246, 250, 1);
  border-radius: 50%;
  align-items: center
}
/deep/.over-view-main-top .over-view-main-top-line {
  justify-content: left!important;
  .over-view-main-top-item {
    margin-right: 0.12rem;
  }
}
/deep/.over-view-main-top .over-view-main-top-line .over-view-main-top-item:nth-child(1) .over-view-main-top-item-img {
  width: 0.385rem;
  height: 0.385rem;
}
/deep/.over-view-main-top .over-view-main-top-line .over-view-main-top-item:nth-child(2) .over-view-main-top-item-img {
  width: 0.4325rem;
  height: 0.38rem;
}
/deep/.over-view-main-top .over-view-main-top-line .over-view-main-top-item:nth-child(3) .over-view-main-top-item-img {
  width: 0.4325rem;
  height: 0.38rem;
}
/deep/.over-view-main-top .over-view-main-top-line .over-view-main-top-item:nth-child(4) .over-view-main-top-item-img {
  width: 0.37rem;
  height: 0.37rem;
}
/deep/.over-view-main-top .over-view-main-top-line .over-view-main-top-item:nth-child(3) .over-view-main-top-item-info-num {
  color: #FF0000;
}
</style>



// WEBPACK FOOTER //
// src/view/LadderControl/LadderOverView/LadderOverView.vue